<template lang="pug">
FetchErrorTransition(:isFetching="isFetching" :error="error")
  .integration-overview
    h1.h1 Integrations
    IntegrationsTable(v-if="integrations" :integrations="integrations")
    p(v-else) There are currently no integrations
</template>

<script>
import IntegrationsTable from '@/vue/settings/application/integrations/IntegrationsTable.vue'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'IntegrationsOverview',
  components: { IntegrationsTable },
  data() {
    return {
      isFetching: true,
      error: null,
    }
  },
  computed: mapState('integrations', ['integrations']),
  methods: mapActions('integrations', ['fetchIntegrations']),
  async mounted() {
    this.isFetching = true
    try {
      await this.fetchIntegrations()
    } catch (e) {
      this.$notifyError('Unable to fetch integrations')
      this.error = e
    }
    this.isFetching = false
  },
}
</script>

<style lang="stylus">
.integration-overview
  text-align left
  padding-left 40px

  h1
    display block
    margin 40px 0 48px 0
</style>
